import React, { Component } from "react";
import axios from "axios";
import FeatherIcon from "feather-icons-react";
import ReactToPrint from "react-to-print";
import SchoolfeeDetail from "../../../components/rh/students/SchoolfeeDetail";
import UserIdentity from "../../users/UserIdentity";
import Headerpdf from "../../users/Headerpdf";

class Schoolfee extends Component {
  state = { studentschoolfees: { schoolfees: [] }, student: {}, isModal: false, loading: true, error: "" };
  componentDidMount() { this.getStudentschoolfees(); }
  getStudentschoolfees = async () => {
    try {
      const response = await axios.get(`/students/schoolfees/${this.props.user}`);
      this.setState({ studentschoolfees: response.data || { schoolfees: [] }, loading: false, error: "" });
    } catch (error) { this.setState({ loading: false, error: "Impossible de charger les paiements." }); }
  };
  showModal = (student = null) => this.setState((state) => ({ isModal: !state.isModal, student }));

  render() {
    const { studentschoolfees, loading, error } = this.state;
    const fees = studentschoolfees.schoolfees || [];
    const totals = fees.reduce((result, fee) => {
      const currency = fee.sectionschoolfeecategory?.currency || "";
      result[currency] = (result[currency] || 0) + Number(fee.pay_mount || 0);
      return result;
    }, {});
    return <div className="student-profile-child">
      <div className="student-profile-child__toolbar"><span>{fees.length} paiement{fees.length === 1 ? "" : "s"}</span>
        {fees.length > 0 && <ReactToPrint trigger={() => <button className="student-profile-print" type="button"><FeatherIcon icon="printer" size={15} /> Imprimer</button>} content={() => this.componentRef} />}
      </div>
      <div ref={(element) => (this.componentRef = element)}>
        <Headerpdf /><UserIdentity matricule={this.props.matricule} name={this.props.name} classe={this.props.classe} title={this.props.title} />
        <div className="print-customer">
          {loading && <div className="student-profile-empty">Chargement des paiements…</div>}
          {error && <div className="student-profile-empty is-error">{error}</div>}
          {!loading && !error && fees.length === 0 && <div className="student-profile-empty"><FeatherIcon icon="credit-card" /><span>Aucun paiement enregistré.</span></div>}
          {fees.length > 0 && <div className="student-profile-records">
            {fees?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).map((fee) => {
              const sc = studentschoolfees.sectionclass;
              const classe = sc ? [sc.class?.short_entitled_class, sc.title, sc.section?.short_entitled_section ? `# ${sc.section.short_entitled_section}` : ""].filter(Boolean).join(" ") : "Classe non renseignée";
              const trimester = fee.trimesectschool?.trimester;
              const trimesterLabel = trimester?.short_trimester || trimester?.trimester;
              const remaining = Number(fee.remaining_amount || 0);
              return <button type="button" className="student-profile-record" key={fee.id} onClick={() => this.showModal(fee)}>
                <span className="student-profile-record__icon"><FeatherIcon icon="credit-card" size={16} /></span>
                <span className="student-profile-record__content"><strong>{fee.sectionschoolfeecategory?.schoolfeecategory?.category || "Paiement scolaire"}</strong><small>{classe} · {fee.year?.year || "Année inconnue"} · {fee.month?.month || "Mois inconnu"}{trimesterLabel ? " · " + trimesterLabel : ""}</small></span>
                <span className="student-profile-record__value"><strong className={remaining > 0 ? "is-warning" : "is-success"}>{Number(fee.pay_mount || 0).toLocaleString()} {fee.sectionschoolfeecategory?.currency}</strong><small>{fee.invoice || "Sans facture"}</small></span>
                <FeatherIcon icon="chevron-right" size={16} />
              </button>;
            })}
            <div className="student-profile-total"><span>Total encaissé</span><strong>{Object.entries(totals).map(([currency, total]) => `${total.toLocaleString()} ${currency}`).join(" · ")}</strong></div>
          </div>}
        </div>
      </div>
      {this.state.isModal && <SchoolfeeDetail isModal={this.state.isModal} student={this.state.student} showModal={this.showModal} />}
    </div>;
  }
}
export default Schoolfee;